import { useQuery } from '@tanstack/react-query';
import type { InvitationDto, MemberDto } from '@cw/shared';
import { api } from './api';
import { qk } from './query';
import { useCan } from './session';

export function useMembers() {
  const can = useCan('members:read');
  return useQuery({ queryKey: qk.members, queryFn: () => api.get<MemberDto[]>('/members'), enabled: can });
}

export function useInvitations() {
  const can = useCan('members:invite');
  return useQuery({
    queryKey: qk.invitations,
    queryFn: () => api.get<InvitationDto[]>('/invitations'),
    enabled: can,
  });
}
